import { useDropzone } from "react-dropzone"
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import React from 'react';

const CustomerUploadLogo = ({logo, setLogo, customer}) => {
  const {getInputProps, getRootProps} = useDropzone({
    accept: "image/*",
    onDrop: acceptedFiles => {
      setLogo(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      );
    }
  })

  const handleRemove = () => {
    setLogo("");
  };

  return (
    <>
      {!logo ? (
        <div {...getRootProps({ className: 'dropzone-area tw-py-5' })}>
          <input {...getInputProps({multiple:false})} />
          <div className="tw-flex tw-justify-center">
            <img src={cloudUpload} alt="" width={25} className="tw-mr-2" />
            <p className="tw-text-sm tw-mb-0 tw-text-slate-600">Drop your logo here</p>
          </div>
        </div>
      ) : (
        <div className="tw-mt-1">
          <div className="tw-flex tw-flex-col tw-items-center">
            <img
              className="tw-rounded-sm tw-max-w-full"
              width={150}
              height={100}
              src={customer && customer.logo_url ? logo : logo[0].preview}
              alt={logo[0].path}
            />
            <Link className="tw-mt-2 tw-text-sm tw-text-red-600" title="Remove logo" onClick={handleRemove}>
              <FaTrash /> Remove
            </Link>
          </div>
        </div>
      )}
    </>
  )
}

CustomerUploadLogo.propTypes = {
  logo: PropTypes.object.isRequired,
  setLogo: PropTypes.func.isRequired,
  customer: PropTypes.object.isRequired
}

export default CustomerUploadLogo;
